import "./App.css";

import React, { Suspense } from "react";

import { useCleanupQueryParams } from "../../hooks/useCleanupQueryParams";
import { PageTemplate } from "../../types/page-template";
import CallManager from "../CallManager";
import MastersManager from "../MastersManager";
import Navigation from "../Navigation";
import { RentalTripAddModal } from "../RentalTripAdd";
import Routes from "../Routes";
import ServiceProvider, { ServiceProviderProps } from "../ServiceProvider";
import StateProvider from "../StateProvider";


// Dev login only exists in development builds. In any other build the import is
// removed at build time, so the switcher code never reaches staging/production.
const DevUserSwitcher =
  process.env.NODE_ENV === "development"
    ? React.lazy(() => import("../DevUserSwitcher"))
    : null;

interface AppProps extends Omit<ServiceProviderProps, "children"> {
  pageTemplates: PageTemplate[];
  intent?: string;
}

function App(props: AppProps) {
  const { pageTemplates, intent, ...rest } = props;

   useCleanupQueryParams(["userProfile"]);

  return (

      <ServiceProvider {...rest}>
        <StateProvider>
          <>
            <Navigation pages={pageTemplates} />
            <Routes
              intent={intent}
              pages={pageTemplates}
            />
            <MastersManager />
            <RentalTripAddModal />
            <CallManager />
            {DevUserSwitcher && (
              <Suspense fallback={null}>
                <DevUserSwitcher />
              </Suspense>
            )}
          </>
        </StateProvider>
      </ServiceProvider>
  );
}

export default App;
